module.exports = __webpack_public_path__ + "static/media/gem3.2fc98db6.png";